import React from 'react';

import { ReactComponent as GatewayIcon } from '@assets/svg/devices/ic-gateway.svg';
import { ReactComponent as MoteIcon } from '@assets/svg/devices/ic-mote.svg';
import { ReactComponent as NodeIcon } from '@assets/svg/devices/ic-node.svg';
import { ReactComponent as RouterIcon } from '@assets/svg/devices/ic-router.svg';
import { ReactComponent as SensorIcon } from '@assets/svg/devices/ic-sensor.svg';
import { ReactComponent as TachometerIcon } from '@assets/svg/devices/ic-tachometer.svg';

import useTranslation from '@hooks/useTranslation';

import style from './style.module.scss';

interface IProps {
  equipmentType?: string;
}

export const EQUIPMENT_TYPE_ICON = {
  gateway: GatewayIcon,
  repeater: RouterIcon,
  node: NodeIcon,
  mote: MoteIcon,
  sensor: SensorIcon,
  tachometer: TachometerIcon,
};

const EquipmentDetailsType: React.FC<IProps> = ({ equipmentType }) => {
  const { t } = useTranslation();

  if (!equipmentType) {
    return null;
  }

  const EquipmentIcon = EQUIPMENT_TYPE_ICON[equipmentType as keyof typeof EQUIPMENT_TYPE_ICON];

  return (
    <div className={style.typeWrapper}>
      <EquipmentIcon className={style.typeIcon} />
      <span className={style.typeName} data-qa={'device-type'}>
        {t(equipmentType)}
      </span>
    </div>
  );
};

export default EquipmentDetailsType;
